// Finance build — query-key factory for the staff Income Overview surface and
// its per-loan events drill. Array-literal query keys live ONLY in *Keys.ts
// files (stale-after-save convention); the hooks in useIncomeOverview import
// this.

import type { IncomeOverviewParams } from "@/api/portfolioAdmin/incomeOverviewApi";

export const incomeOverviewKeys = {
  overview: (params: IncomeOverviewParams) =>
    ["portfolio-admin", "income-overview", params] as const,
  loanEvents: (loanId: string, params: IncomeOverviewParams) =>
    ["portfolio-admin", "income-overview", "loan-events", loanId, params] as const,
};
